import { Icon, IconProps } from '@chakra-ui/react'

export default function FilterIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M21.0036 8.00021H2.99609"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99818 13.0002H2.99609"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99818 18.0041H2.99609"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0036 2.9963H2.99609"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.402 17.5199V20.113C15.3998 20.4221 15.5586 20.7102 15.8211 20.8735C16.0836 21.0368 16.4121 21.0519 16.6885 20.9133L18.1131 20.201C18.4164 20.0499 18.6073 19.7395 18.6053 19.4007V17.5199L20.6592 15.9352C20.8764 15.7677 21.0041 15.5093 21.0053 15.2349V13.8894C21.0053 13.6533 20.9115 13.427 20.7445 13.2601C20.5775 13.0933 20.351 12.9997 20.1149 13H13.8903C13.3992 13 13.001 13.3982 13.001 13.8894V15.2309C13.0023 15.5052 13.13 15.7636 13.3471 15.9312L15.402 17.5199Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
